
  import { Component, Vue } from 'vue-property-decorator'
  import IPSetRepository from '@/services/IPSet';
  import { WPXFormValue } from '@/components/templates/WPXForm';
  import CreateIPSetForm from '@/services/IPSet/forms/CreateIPSetForm';

  @Component({
    inject: [
      'ipsetRepository',
    ],
  })
  export default class CreateIPSetList extends Vue {
    public readonly ipsetRepository!: IPSetRepository
    public form: WPXFormValue<CreateIPSetForm> = new WPXFormValue(CreateIPSetForm)


    public created(): void {
      this.form.data.type = this.form.data.listTypes[0]
    }

    public async createIPSetList(): Promise<void> {
      try {
        await this.ipsetRepository.createIpSetList({
          name: this.form.data.name,
          type: this.form.data.type,
          timeoutSupport: this.form.data.timeoutSupport,
          defaultTimeout: this.form.data.timeoutSupport === true ? Number(this.form.data.defaultTimeout) : undefined,
          commentsSupport: this.form.data.commentsSupport,
          counters: this.form.data.counters,
          skbInfo: this.form.data.skbInfo,
          hashSize: this.form.data.type.startsWith('hash') && this.form.data.hashSizeCheckbox
            ? Number(this.form.data.hashSize) : 0,
          maxElements: this.form.data.type.startsWith('hash') && this.form.data.maxElementsCheckbox
            ? Number(this.form.data.maxElements) : 0,
        })
        this.$successDialog.show(`Successfully created IPSet List '${this.form.data.name}'`)
      } catch (e) {
        this.$errorDialog.show(e.response.data.error)
      }
    }
  }
